import type { KeyboardEvent } from "react";

export const EDITORS =
	'input:not([type="hidden"]):not([disabled]):not([tabindex="-1"]), .MuiSelect-select:not([aria-disabled])';

const CARET_TYPES = new Set(["text", "search", "tel", "url"]);

export const isAtEdge = (element: HTMLElement, step: -1 | 1) => {
	if (!(element instanceof HTMLInputElement))
		return element.classList.contains("MuiSelect-select");

	if (!CARET_TYPES.has(element.type)) return false;

	const { selectionStart, selectionEnd, value } = element;

	if (selectionStart === null || selectionEnd === null) return false;

	if (element.dataset.sections === undefined && selectionStart !== selectionEnd)
		return false;

	return step < 0 ? selectionStart === 0 : selectionEnd === value.length;
};

export const navigationStep = (event: KeyboardEvent<HTMLElement>) => {
	const isTab = event.key === "Tab";
	const back = isTab ? event.shiftKey : event.key === "ArrowLeft";

	if (!isTab && !back && event.key !== "ArrowRight") return null;

	const step: -1 | 1 = back ? -1 : 1;

	return isTab || isAtEdge(event.target as HTMLElement, step) ? step : null;
};

export const focusEditor = (editor: HTMLElement | null | undefined) => {
	if (!editor) return false;

	editor.focus();
	if (editor instanceof HTMLInputElement) editor.select();

	return true;
};

export const stepEditor = (
	root: HTMLElement | null,
	from: HTMLElement,
	step: -1 | 1,
) => {
	const editors = Array.from(
		root?.querySelectorAll<HTMLElement>(EDITORS) ?? [],
	);
	const current = editors.indexOf(from);

	if (current === -1) return false;

	return focusEditor(editors[current + step]);
};
